module.exports = __webpack_public_path__ + "static/fonts/Roboto-Thin.9499847.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Thin.ttf
// module id = 321
// module chunks = 1